<iframe #iframe [src]="threedViewerHref | safe: 'resourceUrl'" width="100%" height="100%"></iframe>
